var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPuzzle = function SvgPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_svg__a",
    x1: 43.5,
    x2: 43.5,
    y1: 23,
    y2: 57.33,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#puzzle_svg__a)",
    d: "M47.477 32a4.956 4.956 0 0 0 1.023-3 5 5 0 0 0-10 0c0 1.131.39 2.162 1.023 3H32v8c.83-.63 1.87-1 3-1 2.76 0 5 2.24 5 5s-2.24 5-5 5c-1.13 0-2.17-.37-3-1v7h18.47c2.5 0 4.53-2.03 4.53-4.53V32h-7.523z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_svg__b",
    x1: 32,
    x2: 32,
    y1: 6.667,
    y2: 57.684,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#puzzle_svg__b)",
    d: "M51 8H13c-2.757 0-5 2.243-5 5v38c0 2.757 2.243 5 5 5h38c2.757 0 5-2.243 5-5V13c0-2.757-2.243-5-5-5zm-41 5c0-1.654 1.346-3 3-3h18v4.851a5.872 5.872 0 0 0-2-.351c-1.803 0-3.494.8-4.64 2.195a6.032 6.032 0 0 0-1.239 5.024c.45 2.267 2.28 4.128 4.554 4.633A5.926 5.926 0 0 0 31 26.149V31h-8.531l1.21 1.603c.537.711.82 1.54.82 2.397 0 1.202-.534 2.33-1.464 3.094-.943.774-2.138 1.067-3.366.823-1.501-.298-2.735-1.514-3.071-3.026a3.956 3.956 0 0 1 .721-3.288L18.531 31H10V13zm21 41H13c-1.654 0-3-1.346-3-3V33h4.85a5.926 5.926 0 0 0-.203 3.325c.505 2.274 2.367 4.104 4.633 4.554.404.08.809.12 1.21.12a5.994 5.994 0 0 0 3.814-1.359A5.983 5.983 0 0 0 26.5 35c0-.688-.119-1.361-.351-2H31v8.531l1.603-1.211a3.956 3.956 0 0 1 3.288-.721c1.512.336 2.728 1.57 3.026 3.071.244 1.227-.049 2.422-.823 3.366-1.31 1.594-3.786 1.933-5.491.644L31 45.468V54zm23-3c0 1.654-1.346 3-3 3H33v-4.851a5.868 5.868 0 0 0 2 .351c1.803 0 3.494-.8 4.64-2.195a6.032 6.032 0 0 0 1.239-5.024c-.45-2.267-2.28-4.128-4.554-4.633a5.926 5.926 0 0 0-3.325.203V33h8.531l-1.211-1.603a3.956 3.956 0 0 1-.721-3.288c.336-1.512 1.57-2.728 3.071-3.026 1.229-.246 2.423.048 3.366.823A3.992 3.992 0 0 1 47.5 29c0 .858-.284 1.687-.82 2.397L45.468 33H54v18zm-4.851-20a5.872 5.872 0 0 0 .351-2c0-1.803-.8-3.494-2.195-4.64-1.395-1.145-3.224-1.596-5.024-1.239-2.267.45-4.128 2.28-4.633 4.554A5.926 5.926 0 0 0 37.851 31H33v-8.531l-1.603 1.211a3.952 3.952 0 0 1-3.288.721c-1.512-.336-2.728-1.57-3.026-3.071-.244-1.227.049-2.422.823-3.366 1.309-1.595 3.783-1.934 5.491-.644L33 18.531V10h18c1.654 0 3 1.346 3 3v18h-4.851z"
  })));
};
export default SvgPuzzle;